import { render } from "./RensponsiveGalleryBigScreen.vue?vue&type=template&id=5f832dc2"
import script from "./RensponsiveGalleryBigScreen.vue?vue&type=script&lang=js"
export * from "./RensponsiveGalleryBigScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__